
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"180","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".06","d":"M170.059-1.992c0 49.991-37.987 90.461-84.78 90.461C38.487 88.47.5 48 .5-1.992c0-49.992 37.987-90.462 84.78-90.462 46.792 0 84.779 40.47 84.779 90.462z","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".12","d":"M282.988-1.992c0 49.991-37.987 90.461-84.779 90.461-46.793 0-84.78-40.47-84.78-90.461 0-49.992 37.987-90.462 84.78-90.462 46.792 0 84.779 40.47 84.779 90.462z","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".16","d":"M228.007 80.085c0 49.991-37.987 90.461-84.78 90.461-46.792 0-84.779-40.47-84.779-90.461 0-49.992 37.987-90.462 84.779-90.462 46.793 0 84.78 40.47 84.78 90.462z","stroke":"#000C1F"}})])
          )
        }
      }
    